import { FC } from 'react';

import {
	AwardRibbonOutline,
	CelebrationStreakOutline,
	ChartBarOutline,
	ChatAlt2Outline,
	ChatAltOutline,
	HistoryOutline,
	IconProps,
	ShoppingCartOutline,
	TargetOutline,
	UsersOutline,
} from '@bonusly/design-system';

import { NavbarItemId } from '../../../schemas/navigation';

export type SidebarItemId = 'oneOnOnes' | 'goals' | 'recaps' | 'team' | 'rewards' | 'incentives' | 'leaderboard' | 'celebrations' | 'advice';

export type SidebarItemConfig = {
	id: SidebarItemId;
	apiId: NavbarItemId;
	translationKey: string;
	icon: FC<IconProps>;
};

export const SIDEBAR_ITEMS: SidebarItemConfig[] = [
	{
		id: 'oneOnOnes',
		apiId: 'one_on_ones',
		translationKey: 'links.oneOnOnes',
		icon: ChatAlt2Outline,
	},
	{
		id: 'goals',
		apiId: 'goals',
		translationKey: 'links.goals',
		icon: TargetOutline,
	},
	{
		id: 'recaps',
		apiId: 'recaps',
		translationKey: 'links.recaps',
		icon: HistoryOutline,
	},
	{
		id: 'team',
		apiId: 'team',
		translationKey: 'links.team',
		icon: UsersOutline,
	},
	{
		id: 'rewards',
		apiId: 'rewards',
		translationKey: 'links.rewards',
		icon: ShoppingCartOutline,
	},
	{
		id: 'incentives',
		apiId: 'incentives',
		translationKey: 'links.incentives',
		icon: AwardRibbonOutline,
	},
	{
		id: 'leaderboard',
		apiId: 'leaderboard',
		translationKey: 'links.leaderboard',
		icon: ChartBarOutline,
	},
	{
		id: 'celebrations',
		apiId: 'celebrations',
		translationKey: 'links.celebrations',
		icon: CelebrationStreakOutline,
	},
	{
		id: 'advice',
		apiId: 'advice',
		translationKey: 'links.feedback',
		icon: ChatAltOutline,
	},
];

const DEFAULT_MAIN_NAV_ITEM_IDS: SidebarItemId[] = ['oneOnOnes', 'rewards', 'celebrations', 'leaderboard', 'incentives', 'team'];
const DEFAULT_MORE_MENU_ITEM_IDS: SidebarItemId[] = ['goals', 'advice', 'recaps'];

export const SIDEBAR_API_TO_ITEM_ID: Record<NavbarItemId, SidebarItemId> = SIDEBAR_ITEMS.reduce(
	(map, item) => ({
		...map,
		[item.apiId]: item.id,
	}),
	{} as Record<NavbarItemId, SidebarItemId>
);

export const SIDEBAR_ITEM_TO_API_ID: Record<SidebarItemId, NavbarItemId> = SIDEBAR_ITEMS.reduce(
	(map, item) => ({
		...map,
		[item.id]: item.apiId,
	}),
	{} as Record<SidebarItemId, NavbarItemId>
);

export const getDefaultMainNavItemIds = () => [...DEFAULT_MAIN_NAV_ITEM_IDS];
export const getDefaultMoreMenuItemIds = () => [...DEFAULT_MORE_MENU_ITEM_IDS];
